export default __webpack_public_path__ + "732e291b24ef230f5378b6351d7976f5.png";